import { observer } from 'mobx-react';
import { SinglePropertyInformationForm } from '../properties/borrowerLoanSubmission/singlePropertyInformationForm';

export const SinglePropertyPropertyInformationStep = observer(({ store, substep, quoteStore }) => {
  return <SinglePropertyInformationForm store={store} substep={substep} quoteStore={quoteStore} />
});